var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05862 6.5C8.45883 6.5 8.78326 6.82443 8.78326 7.22464V10.8261C8.78326 11.2263 8.45883 11.5507 8.05862 11.5507C7.65842 11.5507 7.33398 11.2263 7.33398 10.8261V7.22464C7.33398 6.82443 7.65842 6.5 8.05862 6.5Z",
    fill: "#6A1FC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 1.44928C4.38212 1.44928 1.44928 4.38214 1.44928 8.00001C1.44928 11.6179 4.38212 14.5507 7.99999 14.5507C11.6179 14.5507 14.5507 11.6179 14.5507 8.00001C14.5507 4.38215 11.6179 1.44928 7.99999 1.44928ZM0 8.00001C0 3.58173 3.5817 0 7.99999 0C12.4183 0 16 3.58173 16 8.00001C16 12.4183 12.4183 16 7.99999 16C3.58171 16 0 12.4183 0 8.00001Z",
    fill: "#6A1FC2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.05729,
    cy: 5.02018,
    r: 0.666667,
    fill: "#6A1FC2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.347d33a42b9f3bf45b86bfcb04289972.svg";
export { ForwardRef as ReactComponent };